<template>
    <div class="page" :class="$style.root">

        <a-spin :spinning="spinningView">
            <div class="dsd">
                <div style="max-width: 1180px; margin: auto;">
                    <a-row :gutter="[20, 16]">
                        <a-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                            <div
                                v-if="videoDetail"
                                style="
                                    font-size: 18px;
                                    max-width: 1180px;
                                    margin: auto;
                                    line-height: 30px; ">
                                {{ videoDetail.result?videoDetail.result.media_name:'' }}
                            </div>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[20, 16]">
                        <a-col :xs="24" :sm="24" :md="18">
                            <a-spin :spinning="videoDetailLoading">
                                <div class="spin-content" style="height: 500px;">

                                    <div style="height: 500px; width: 100%;" id="dplayer"></div>
                                </div>
                               
                            </a-spin>
                            
                        </a-col>
                       
                    </a-row>
                </div>
            </div>
        </a-spin>
        <!--{{videoDetail}}-->

        <a-modal
            title="输入密码观看"
            v-model="isVisible"
            :footer="false"
            @cancel="handleCancel"
            centered>
            <a-form :form="form" @keyup.enter.native="onSubmit">
                <a-form-item>
                    <a-input-password
                        size="large"
                        placeholder="请输入观看密码"
                        v-decorator="['password', formFields.password]">
                        <template #prefix>
                            <font-icon type="icon-mima" />
                        </template>
                    </a-input-password>
                </a-form-item>
            </a-form>
            <div class="columns"></div>
            <div class="columns">
                <a-button
                    size="large"
                    type="primary"
                    class="column"
                    block
                    @click="onSubmit">确定
                </a-button>
                <div class="whitespace"></div>
            </div>
        </a-modal>



    
        
    </div>
</template>


<script>
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    // import { videoPlayer } from 'vue-video-player';
    import VueCoreVideoPlayer from 'vue-core-video-player';
    import VueDPlayer from 'vue-dplayer';
    import newVideoView from '../../components/newVideoView.vue';
    import Commet from './compontents/Commet.vue';
    const CryptoJS = require('crypto-js');


    export default {
        name: 'VideoDetailView',
        components: {
            'd-player': VueDPlayer,

        },
        data() {
            return {
                isVisibleDownload: false,
                defalutLogoUrl: `this.src="${require('@/assets/LOGO_bg.png')}"`,
                spinningView: true,
                videoDetailContent: [],
                content: [],
                comment: false,
                iscomment: 0,
                pwd: null,
                videoDetailLoading: true,
                programid: null,
                form: this.$form.createForm(this),
                isVisible: false,
                mediaId: '',
                spinning: true,
                delayTime: 500,
                recommendedList: [],
                comments: [],
                submitting: false,
                value: '',
                like: false,
                collect: false,
                baseUrl: '',
                baseIMggUrl: '',
                addStatus: true,
                formFields: {
                    account: {
                        validateFirst: true,
                        validateTrigger: ['blur', 'change'],
                        rules: [
                            {
                                required: true,
                                message: '请输入用户名',
                                whitespace: true,
                            },
                        ],
                    },
                    password: {
                        validateTrigger: ['blur', 'change'],
                        rules: [{
                            required: true,
                            message: '请输入密码',
                        }],
                    },
                },

                playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                    autoplay: true, // 如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'none', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: '', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: '', // url地址
                    }],
                    // poster: "../../static/images/test.jpg", //你的封面地址
                    // width: document.documentElement.clientWidth, //播放器宽度
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true, // 全屏按钮
                    },
                },
                videoSource: [],
                options: {
                    container: document.getElementById('dplayer'),
                    video: {},
                    defaultQuality: 0,
                    autoplay: true, // 可选，自动播放视频，不支持移动浏览器
                    theme: '#FADFA3', // 可选，主题颜色，默认: #b7daff
                    loop: false, // 可选，循环播放音乐，默认：true
                    lang: 'zh-cn', // 可选，语言，`zh'用于中文，`en'用于英语，默认：Navigator
                    preload: 'auto',
                    enableWorker: true,
                    lazyLoadMaxDuration: 3 * 60,
                    seekType: 'range',
                    fixAudioTimestampGap: false,
                },
                dp: null,
            };
        },
        computed: {
            ...mapState(['userInfo']),
            ...mapState('videoDetailStore', ['videoDetail', 'videoRecommendedlist', 'fileList']),
            ...mapState('params', ['liveParams']),
            detailVideoList() {
                const { mediaId } = this.$route.params;

                console.log(this.videoRecommendedlist);
                console.log(
                    this.videoRecommendedlist.filter((item, index, arr) => item.media_id != mediaId),
                );
                return this.videoRecommendedlist.filter((item, index, arr) => item.media_id != mediaId);
            },
        },
        watch: {
            $route: {
                handler(val, oldVal) {
                    const { params } = this.$route.params;
                    window.scrollTo(0, 0);

                    this.handleLoadList();
             
                },
                // 深度观察监听
                deep: true,
            },
        },
        mounted() {
        
            let aa=this.$router.params;    
           const { domain } = document;
                
            const URL = `http://${window.location.host}/files/`;
            this.baseUrl = URL;
            const URL2 =`http://${document.domain}:8000/`;
            this.baseIMggUrl = URL2;
            this.handleLoadList();
         

        // this.recommendedList=this.videoRecommendedlist;
        //
        },
        methods: {
            ...mapActions('videoDetailStore', [
                'getNoAuthVideoDetailDetail',
                'getRecommendedList',
                'getDetail',
                'addView',
                'recordDownloads',
                'getVideoTrick',
                'getFileList',
            ]),
            ...mapActions('PersonalCenter', ['likeList', 'collectList']),

            // 加载s视频内容id
            handleLoadList() {
                // this.dp= new DPlayer(this.options);


                const { mediaId } = this.$route.params;
                debugger
                this.comment = false;
                this.videoDetailLoading = false;
                this.$forceUpdate();
                console.log(mediaId);
                // this.getvideoDetailDetail({ id });
                this.getNoAuthVideoDetailDetail({ id: mediaId })
                    .then((res) => {
                        debugger;
                        if (!res.data.result) {
                            this.$message.warning('视频不存在或被删除下架');
                            setTimeout(this.$router.back(-1), 3000);

                            return;
                        }

                        if (!res.data) {
                            this.$message.error('视频不存在或被删除');
                            setTimeout(this.$router.back(-1), 3000);
                            return;
                        }

                        if (res.data.result.publish == 0) {
                            this.$message.warning('视频不存在或被删除下架');
                            setTimeout(this.$router.back(-1), 3000);

                            return;
                        }

                        if (res.data.result.pwd) {
                            this.isVisible = true;
                            this.pwd = res.data.result.pwd;
                            this.content = res.data.program.tracks;
                        } else {
                            this.videoDetailLoading = false;
                            console.log('45445');
                            this.comment = true;
                            this.videoDetailContent = res.data.program.tracks;
                            this.like = !!res.data.result.is_like;
                            this.collect = !!res.data.result.is_collection;
                            this.iscomment = res.data.result.iscomment;
                            this.spinningView = false;
                            const sources = [];
                    
                            this.videoDetailContent.forEach((item, index) => {
                                const list = {
                                    name: index == 0 ? '高清' : '标清',
                                    url: `${this.baseUrl + this.videoDetail.program.program_id}/${item.name}.mp4`, // url地址
                                    type: 'normal',
                                };

                                sources.push(list);
                            });
                            

                            console.log(sources, sources[0].url);
                            this.videoSource = sources;
                            this.playerOptions.sources = sources;
                            this.options.video.url = sources[0].url;
                            const dp = new DPlayer({
                                container: document.getElementById('dplayer'),
                                screenshot: true,
                                video: {
                                    defaultQuality: 0,
                                    quality: sources,
                                    type: 'mpt',

                                },
                                autoplay: true, // 可选，自动播放视频，不支持移动浏览器
                                theme: '#FADFA3', // 可选，主题颜色，默认: #b7daff
                                loop: false, // 可选，循环播放音乐，默认：true
                                lang: 'zh-cn', // 可选，语言，`zh'用于中文，`en'用于英语，默认：Navigator
                                preload: 'auto',
                                enableWorker: true,
                                lazyLoadMaxDuration: 3 * 60,
                                seekType: 'range',
                                fixAudioTimestampGap: false,
                            });
                            this.dp = dp;

                        }
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
            },
      
            // 推荐列表
            handRecommendedList() {
                let queries = {};
                const orgId = this.userInfo.org_id || '';
                // const _this = this;
                queries = {
                    orgId: orgId || '',
                    orderType: '3',
                };
                if (!this.userInfo.org_id) {
                    delete queries.orgId;
                }

                
                this.getRecommendedList(queries)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
            },
            handleSubmit() {
                if (!this.value) {
                    return;
                }

                this.submitting = true;

                setTimeout(() => {
                    this.submitting = false;
                    this.comments = [
                        {
                            author: 'Han b',
                            avatar:
                                'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
                            content: this.value,
                            datetime: moment()
                                .fromNow(),
                        },
                        ...this.comments,
                    ];
                    this.value = '';
                }, 1000);
            },
            handleChange(e) {
                this.value = e.target.value;
            },
        
           
            addViews() {
                const { mediaId } = this.$route.params;

                const myvideo = document.getElementById('myvideo');

                console.log(myvideo);

                // myvideo.addEventListener('play', () => {
                const formData = {
                    mediaId,
                };
                if (!this.addStatus) {
                    return;
                }
                if (!mediaId) {
                    return;
                }
        
         
                const box = document.getElementsByClassName('dplayer-menu')[0];
                box.remove();
            },

            addDownloads() {
                const { mediaId } = this.$route.params;

                const myvideo = document.getElementById('myvideo');

                console.log(myvideo);

                // myvideo.addEventListener('play', () => {
                const formData = {
                    mediaId,
                };
           
                if (!mediaId) {
                    return;
                }
                // console.log("1221121")
                this.recordDownloads(formData)
                    .then(() => {
                   
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
         
            },
            beforedownload() {
                if (this.videoDetailContent.length > 1) {
                    this.isVisibleDownload = true;
                } else {
                    this.download(0);

                }
            },
            download(quilt) {
                this.addDownloads();
                const { domain } = document;
                if (this.videoDetailContent) {

                    let program_id=this.videoDetail.program.program_id;

                    console.log(program_id);
                    const url = `http://${domain}/files/${program_id}/${this.videoDetailContent[quilt].name}.mp4`;
                    
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${this.videoDetail.result.media_name}.mp4`;
                    a.click();
                }
            },
            onSubmit() {
                const { pwd, content } = this;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const { password } = values;

                    const cpwd = pwd ? CryptoJS.AES.decrypt(pwd, '秘钥').toString(CryptoJS.enc.Utf8) : null;
                    console.log(cpwd, pwd, password);

                    if (password === cpwd) {
                        this.videoDetailLoading = false;
                        this.comment = true;
                        this.videoDetailContent = content;
                        this.isVisible = false;
                        this.like = !!this.videoDetail.result.is_like;
                        this.collect = !!this.videoDetail.result.is_collection;
                        this.iscomment = this.videoDetail.result.iscomment;
                    
                        this.spinningView = false;
              
                        const sources = [];
                        this.videoDetailContent.forEach((item, index) => {
                            const list = {
                                name: index == 0 ? '高清' : '标清',
                                url: `${this.baseUrl + this.videoDetail.program.program_id}/${item.name}.mp4`, // url地址
                                type: 'normal',
                            };

                            sources.push(list);
                        });

                        console.log(content, sources, sources[0].url);
                        this.videoSource = sources;
                        this.playerOptions.sources = sources;
                        this.options.video.url = sources[0].url;
                        const dp = new DPlayer({
                            container: document.getElementById('dplayer'),
                            screenshot: true,
                            video: {
                                defaultQuality: 0,
                                quality: sources,
                                type: 'mpt',
                            },
                            autoplay: true, // 可选，自动播放视频，不支持移动浏览器
                            theme: '#FADFA3', // 可选，主题颜色，默认: #b7daff
                            loop: false, // 可选，循环播放音乐，默认：true
                            lang: 'zh-cn', // 可选，语言，`zh'用于中文，`en'用于英语，默认：Navigator
                            preload: 'true',
                            enableWorker: true,
                            lazyLoadMaxDuration: 3 * 60,
                            seekType: 'range',
                            fixAudioTimestampGap: false,
                            contextmenu: [
                                {
                                    text: 'custom1',
                                    link: '',
                                },
                                {
                                    text: 'custom2',
                                    click: (player) => {
                                        console.log(player);
                                    },
                                },
                            ],
                        });
                        this.dp = dp;
              
                        this.onReset();
                        const box = document.getElementsByClassName('dplayer-menu')[0];
                        box.remove();
                    } else {
                        this.$message.error('密码错误');
                    }


                // const box2 = document.getElementsByClassName('dplayer-setting')[0];
                // box2.remove();
                });
            },
            onReset() {
                this.form.resetFields();
            },
            toRecommend() {
                this.$router.push({ name: 'RecommendView' });
            },
            loadVideoTrick(id) {
                this.getVideoTrick({ id })
                    .then(() => {
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
            },
            handleCancel() {
                this.$router.back(-1);
            },
            goVideoDetail(mediaId) {
                //   this.storageLiveParams({ mediaId });
                this.$router.push({
                    name: 'VideoDetailView',
                    params: { mediaId },
                });
            },
            onPlayererror() {
                this.$refs.videoPlayer.pause();
            },
            initVideo() {
            // 初始化视频方法
            },
            isVisibleDownloadCancel() {
                this.isVisibleDownload = false;
            },
            laodFile(index) {
                const n = this.fileList[index];
                const { domain } = document;

                const url = `http://${domain}/file?cmd=downloadAttchment&programId=${this.videoDetail.result.programId}&fileName=${n}`;
                // http://ip/file?cmd=downloadAttchment&programId=xxx&fileName=xxx
                const a = document.createElement('a');
                a.href = url;
                a.download = n;

                a.click();
            },

            player(url) {

            },
        },
        // eslint-disable-next-line vue/order-in-components
        updated() {
            window.scroll(0, 0);
        },
        beforeDestroy() {
            if (this.dp) {
                this.dp.destroy();
            }
            this.dp = null;
        },
        // eslint-disable-next-line vue/order-in-components
        destroyed() {
            this.onReset();

            if (this.dp) {
                this.dp.destroy();
            }
            this.dp = null;
        },
    };
</script>

<style lang="less" module>
    .root {
        width: 100%;
        display: flex;
        flex-direction: column;

        :global {
            display: flex;
            flex-direction: column;

            .companyName {
                white-space: nowrap;
            }

            .filelist {
                line-height: 30px;
            }

            video::-webkit-media-controls-fullscreen-button {
                display: none;
            }

            .btn {
                margin: -20px 0 -20px 10px;
                display: none;
            }

            .ant-table-row:hover {
                .btn {
                    display: inline-block;
                }
            }

            .video-play {
                max-width: 1180px;
                margin: auto;
                background: #2c374a;

                /* // height: 668px; */
                // padding-top: 20px;
            }

            .video-play-box {
                max-width: 1180px;
                // height: 556px;
                margin: 0 auto;
                background: #242629;
            }

            .video-play-box .video-play-video {
                width: 100%;
                // max-height: 664px;
                border: none;
                outline: none;
            }

            .video-play-info {
                max-width: 1180px;
                height: 68px;
                margin: 0 auto;
                background: #161617;
            }

            .video-play-info span {
                height: 68px;
                line-height: 68px;
                font-size: 24px;
                color: #bfbfbf;
                padding-left: 20px;
            }

            .video-share-icon {
                width: 38px;
                height: 38px;
                float: right;
                background: url(../../assets/icon-share.png) no-repeat center;
                margin: 15px 20px 0 0;
                cursor: pointer;
                position: relative;
            }

            .video-share-icon:hover .video-share {
                display: block;
            }

            .video-share {
                width: 168px;
                height: 176px;
                background: url(../../assets/code-box.png);
                position: absolute;
                top: 26px;
                left: -88px;
                display: none;
            }

            .video-share-code {
                width: 132px;
                height: 132px;
                background: #30c;
                margin: 26px 0 0 18px;
            }

            .video-share-code img {
                width: 100%;
                height: 100%;
            }

            .box-newshot {
                padding-top: 30px;
                max-width: 1200px;
                width: 1200px;
                height: 320px;
                margin: auto;
                overflow: hidden;

                .title {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    color: #435573;
                    margin-bottom: 10px;
                    padding-left: 10px;
                }
            }

            .box-comment {
                padding-top: 30px;
                max-width: 1180px;
                width: 100%;
                margin: auto;
            }

            .m-titlecomment {
                line-height: 50px;
                font-size: 18px;
            }

            .f-clbox {
                display: flex;
                flex-direction: row;
                color: #fff;
                height: 30px;
                line-height: 30px;
                //margin: 0 20px;
                padding: 0 20px;
                justify-content: space-between;
            }

            .f-clbox > div {
                width: 100px;
            }

            .more {
                float: right;
                font-size: 12px;
                cursor: pointer;
            }

            .detail {
                // width: 110px;
                width: 100%;
                height: 90px;
                // background: url(../../assets/LOGO_bg.png) 100%;
            }

            .meaianame-text {
                font-size: 14px;
                line-height: 2;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
    }
</style>
